const Item = props => {
    const {children, ...rest} = props;
    return children(rest);
};

export default Item;
